import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { Table, Spinner, Modal, Button, Form } from 'react-bootstrap';
import RefershIcon from '../../../common/assets/images/reload.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import axiosInstance from '../../../axiosinterceptor';

const ModuleManagement = () => {
    const navigate = useNavigate();
    const permissions = JSON.parse(sessionStorage.getItem('permissions'));

    useEffect(() => {
        if (permissions && !permissions.admin) {
            navigate('/no-access');
        }
    }, [permissions, navigate]);

    const [modules, setModules] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [editingModule, setEditingModule] = useState(null);
    const [moduleName, setModuleName] = useState('');
    const [deletingModule, setDeletingModule] = useState(null);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        const fetchModules = async () => {
            setIsLoading(true);
            try {
                const response = await axiosInstance.get("/getAdminModulesACS");
                setModules(response.data.data); // Access the 'data' property
            } catch (error) {
                // console.error('Error fetching modules:', error);
                toast.error(error.response?.data?.message || "Error fetching modules.");
                
                
            }
            setIsLoading(false);
        };
        fetchModules();
    }, [refresh]);

    const handleShowModal = (module = null) => {
        setEditingModule(module);
        setModuleName(module ? module.module_name : '');
        setShowModal(true);
    };

    const handleSave = async () => {
        if (!moduleName.trim()) {
            toast.error('Module name cannot be empty!');
            return;
        }

        const isDuplicate = modules.some(
            (module) =>
                module?.module_name?.toLowerCase() === moduleName.toLowerCase() &&
                (!editingModule || module?.module_id !== editingModule?.module_id)
        );

        if (isDuplicate) {
            toast.error('Module name already exists!');
            return;
        }

        if (editingModule) {
            try {
                const response = await axiosInstance.put(`/updateAdminModulesACS`, {
                    newModuleName: moduleName,
                    newupdatedBy: sessionStorage.userId,
                    moduleId: editingModule.module_id,
                });
                // console.log("Successfully edited:", moduleName);
                toast.success(response.data.message);

                setModules((prev) =>
                    prev.map((module) =>
                        module?.module_id === editingModule.module_id ? { ...module, module_name: moduleName } : module
                    )
                );
            } catch (error) {
                // console.error('Error updating module:', error);
                // toast.error('Failed to update module');
                toast.error(error.response?.data?.message || "Failed to update module.");
                
            }
        } else {
            try {
                const response = await axiosInstance.post("/postAdminModulesACS", {
                    moduleName: moduleName,
                    createdBy: sessionStorage.userId,
                });
                // console.log("Successfully added:", moduleName);
                toast.success(response.data.message);

                setModules((prev) => [...prev, response.data.data]);
            } catch (error) {
                // console.error('Error adding module:', error);
                // toast.error('Failed to add module');
                toast.error(error.response?.data?.message || "Failed to add module.");
                
            }
        }

        setShowModal(false);
        setRefresh(!refresh);
    };

    const handleShowDeleteModal = (module) => {
        setDeletingModule(module);
        setShowDeleteModal(true);
    };

    const handleDelete = async () => {
        if (!deletingModule) return;

        // console.log("Deleting Module:", deletingModule.module_name);

        try {
            const response = await axiosInstance.delete(`/deleteAdminModules?moduleId=${deletingModule.module_id}`);
            // console.log("Successfully deleted:", deletingModule.module_name);
            toast.success(response.data.message);

            setModules((prev) => prev.filter((module) => module?.module_id !== deletingModule.module_id));
        } catch (error) {
            // console.error('Error deleting module:', error);
            // toast.error('Failed to delete module');
            toast.error(error.response?.data?.message || "Failed to update role.");
            
        }

        setShowDeleteModal(false);
        setRefresh(!refresh);
    };

    const handleRefresh = () => {
        setRefresh(!refresh);
    };

    return (
        <div className="userlist-section">
            <ToastContainer autoClose={5000} />
            <div className="userlist-header">
                <h4 className="userlist-header-text">Modules</h4>
                <div className="userlist-filter-section">
                    <button className="userlist-filter-btn" onClick={() => handleShowModal()}>
                        Add Module
                    </button>
                    <span className="userlist-refresh-btn" onClick={handleRefresh}>
                        <span>
                            <img src={RefershIcon} alt="Refresh" />
                        </span>
                    </span>
                </div>
            </div>
            <div className="userlist-table-container">
                <Table responsive="sm" style={{ textAlign: 'center' }} className="userlist-filter-table">
                    <thead className="userlist-thead">
                        <tr className="userlist-tr">
                            <th className="userlist-th">Module ID</th>
                            <th className="userlist-th">Module Name</th>
                            <th className="userlist-th">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="3">
                                    <div className="userlist-table-loader">
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        ) : modules && modules.length > 0 ? (
                            modules.map((module) => (
                                module && module.module_id ? (
                                    <tr key={module.module_id}>
                                        <td className="userlist-td">{module.module_id}</td>
                                        <td className="userlist-td">{module.module_name}</td>
                                        <td className="userlist-td">
                                            <FontAwesomeIcon
                                                icon={faPenToSquare}
                                                className="iconuser-update"
                                                onClick={() => handleShowModal(module)}
                                            />
                                            <FontAwesomeIcon
                                                icon={faTrash}
                                                className="iconuser-update"
                                                onClick={() => handleShowDeleteModal(module)}
                                            />
                                        </td>
                                    </tr>
                                ) : null
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3">
                                    <p className="mb-0">No Records Found</p>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{editingModule ? 'Edit Module' : 'Add Module'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Module Name:</Form.Label>
                            <Form.Control
                                type="text"
                                value={moduleName}
                                onChange={(e) => setModuleName(e.target.value)}
                                placeholder="Module Name"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={handleSave}>
                        {editingModule ? 'Update' : 'Save'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete the module "<b>{deletingModule?.module_name}</b>"?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={handleDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default ModuleManagement;